// extracted by mini-css-extract-plugin
export var containerGallery = "styles-module--containerGallery--dfM+P";
export var containerSlider = "styles-module--containerSlider--vE1z3";
export var flexContainer = "styles-module--flexContainer--Bl-94";
export var img = "styles-module--img--NciLE";
export var text = "styles-module--text--N0MXk";
export var textWrapper = "styles-module--textWrapper--yJHL7";